<template>
  <div>
    <!-- 기본 -->
    <basic-oneto-one-new v-if="!isLaunchpack"></basic-oneto-one-new>

    <!-- 마스터 백오피스 -->
    <launchpack-oneto-one-new v-if="isLaunchpack"></launchpack-oneto-one-new>
  </div>
</template>

<script>

  import BasicOnetoOneNew from "./BasicOnetoOneNew";
  import LaunchpackOnetoOneNew from "./LaunchpackOnetoOneNew";

  export default {
    name: 'OnetoOneNew',
    layout: 'Main',
    components: {
      LaunchpackOnetoOneNew,
      BasicOnetoOneNew
    },
    data() {
      return {
      }
    },
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
